import script from "./column.vue?vue&type=script&lang=ts&setup=true"
export * from "./column.vue?vue&type=script&lang=ts&setup=true"

import "./column.vue?vue&type=style&index=0&id=773e4965&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773e4965"]])

export default __exports__